import { render, staticRenderFns } from "./RedirectPayfipPayment.vue?vue&type=template&id=5fc7c148&"
import script from "./RedirectPayfipPayment.vue?vue&type=script&lang=js&"
export * from "./RedirectPayfipPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports